import * as React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import * as stores from './liveStores';
import * as aspxApi from './api/live/apiAspxNotification';
import {
    createDateFormaterSvc, createConsoleLoggingService, createSilentLoggingService, ILoggingService,
    TicketStorage, createConnectionMonitorService, AppType, setDrawReplaceValues, InitSettings, sessionPlayerToPlayer, UserService, createStorageWithSessionStorage, createStorageWithLocalStorage, connectVirtualGamesGroupedApi, ICouponSentData, setGAServiceLoggingService
} from 'eTip--common';
import { translation, getAvailableLanguages, setLoggingService as setLocalizationLoggingService, setCurrency, setLocale } from 'easit--localization';
import { AppLoader, AppLoaderMts } from 'common--design-library';
import { ILiveAppEnv, ILiveApiSettings } from "./liveAppEnvironment";
import { connectSportsBettingGroupedApiFakeData } from './api/live/fakeData/fakeData';
import { SRNotificationHandlerFake } from './api/live/fakeData/SRNotificationHandlerFake';
import { App } from './liveApp';
import { createSportsBettingSessionApi, connectSportsBettingGroupedSessionApi } from './api/apiSession';
import { connectSportsBettingLiveGroupedApi, ISportsBettingLiveApi } from './api/live/api';
import { SRNotificationHandler } from 'eTip--common';
import { setFormatLocale } from '../../localization/localization';
import { createSoundService } from '../eTipCommon/services/soundService';
import { createScoreChangeMonitor } from '../eTipCommon/services/scoreChangeMonitor';
import { IGroupedApi } from '../eTipCommon/api/apiCommon';
import { IConnectionMonitorService } from '../eTipCommon/services/connectionMonitorService';
import { Instance } from 'mobx-state-tree';
import { createDateTimeWithHeartbeatServiceMts } from '../eTipCommon/services/dateTimeService';
import { AxiosResponse } from 'axios';
import { TelemetryService } from '../eTipCommon/services/telemetryService';
import { LiveStreamMonitor } from '../eTipCommon/models/liveStream';
import { paths } from './liveRouting';
import { chatConfigService } from '../eTipCommon/models/chat/setup';
import { IRecaptchaProvider, RecaptchaProvider } from '../eTipCommon/recaptcha/recaptchaProvider';

const develTokenVersion = __DevelTokenVersion__;
const develLanguageId = __DevelLanguageId__;
const develTimeZoneOffsetMin = -new Date().getTimezoneOffset();
let isLocalDevelopment = process.env.NODE_ENV === 'development';

const webservicesuffix = '/WebServices/Api';

export function run() {

    const rootEl = isLocalDevelopment ? document.getElementById('root') : document.getElementById('reactAppRoot');

    let loggingService: ILoggingService;
    try {

        let aspxApiInstance = isLocalDevelopment
            ? aspxApi.connectDevelAspxApi(
                getAvailableLanguages().get(develLanguageId),
                develTokenVersion,
                develTimeZoneOffsetMin
            )
            : aspxApi.connectRealAspxApi();
        let launchSettings = aspxApiInstance.getSettings();
        let baseUrl = launchSettings.apiBaseUrl;
        const dateTimeFormatterForSvc = createDateFormaterSvc();

        loggingService = launchSettings.isDebug ? createConsoleLoggingService() : createSilentLoggingService();
        aspxApiInstance.init(loggingService);

        const connectionMonitorService = createConnectionMonitorService(launchSettings.connectionTimeoutMs, null, loggingService);
        const recaptchaProvider = new RecaptchaProvider(launchSettings.recaptchaSiteKey);
        let sessionApi = createSportsBettingSessionApi({ baseUrl: baseUrl, settings: launchSettings, aspxApi: aspxApiInstance, dateTimeFormatter: dateTimeFormatterForSvc }, loggingService, connectionMonitorService, recaptchaProvider);

        setLocale(launchSettings.language.abbreviation); //register translations in parent!

        setLocalizationLoggingService(loggingService);
        setGAServiceLoggingService(loggingService);
        setFormatLocale(launchSettings.language.abbreviation);
        setCurrency(launchSettings.currency, launchSettings.pointsCurrency);
        setDrawReplaceValues(launchSettings.drawTipName, translation().general_OddsDraw);

        const sRNotificationHandler = __UseFakeData__ ? new SRNotificationHandlerFake(false) : new SRNotificationHandler(chatConfigService.isChatFeatureAvailable(launchSettings));

        sessionApi
            .getInitDataAsync(AppType.FullLive)
            .then((response: AxiosResponse<InitSettings>) => {
                try {

                    sRNotificationHandler.startSubscribing(baseUrl + webservicesuffix, response.data.Token, launchSettings.language.id, launchSettings.canDisableSignalRSSE, connectionMonitorService, loggingService);

                    let fn: (data: any, logService: ILoggingService, c: IConnectionMonitorService, r: IRecaptchaProvider) => IGroupedApi<ISportsBettingLiveApi> = __UseFakeData__ ? connectSportsBettingGroupedApiFakeData : connectSportsBettingLiveGroupedApi;

                    const sportsBettingApi: IGroupedApi<ISportsBettingLiveApi> = fn({
                        dateTimeFormater: dateTimeFormatterForSvc,
                        baseUrl: baseUrl,
                        sessionApi: sessionApi,
                        settings: launchSettings,
                        token: response.data.Token
                    }, loggingService, connectionMonitorService, recaptchaProvider);

                    const dateTimeAndHeartbeatService = createDateTimeWithHeartbeatServiceMts(launchSettings.serverOffsetMin, sessionApi, loggingService, connectionMonitorService);
                    const soundService = createSoundService(loggingService, launchSettings.soundFilesBaseUrl);

                    const telemetryService = new TelemetryService(launchSettings, loggingService, sportsBettingApi);
                    const sessionStorage = createStorageWithSessionStorage();

                    const pathsInstance = paths();

                    const env: ILiveAppEnv = {
                        api: sportsBettingApi,
                        aspxApi: aspxApiInstance,
                        virtualGamesApi: __IsMTS__ ? connectVirtualGamesGroupedApi({ baseUrl: launchSettings.apiVirtualGamesBaseUrl, dateTimeFormater: dateTimeFormatterForSvc, token: response.data.Token }) : null,
                        dateTimeService: dateTimeAndHeartbeatService,
                        sRNotificationHandler: sRNotificationHandler,
                        heartbeatService: dateTimeAndHeartbeatService,
                        settings: launchSettings,
                        settingsFromApi: getApiSettings(response.data.Settings.ReturnValue),
                        loggingService,
                        sessionApi: connectSportsBettingGroupedSessionApi(sessionApi),
                        loggedUserId: response.data.SessionPlayer.ReturnValue.ID,
                        userToken: response.data.Token,
                        player: sessionPlayerToPlayer(response.data.SessionPlayer.ReturnValue),
                        ticketStorage: new TicketStorage(sessionStorage),
                        telemetryService: telemetryService,
                        soundService: soundService,
                        scoreChangeMonitor: createScoreChangeMonitor(soundService),
                        couponSent: (data: ICouponSentData) => {
                            aspxApiInstance.couponSent(data);
                        },
                        liveStreamMonitorFactory: () => { return new LiveStreamMonitor(loggingService, telemetryService, false); },
                        sessionStorage: sessionStorage,
                        localStorage: createStorageWithLocalStorage(),
                        routing: {
                            getPublicTicketPath: (ticketId: string) => {
                                return pathsInstance.getTicketDetailPublic(ticketId);
                            },
                            getLegacyPublicTicketPath: (ticketId: string) => {
                                return pathsInstance.getLegacyTicketDetailPublic(ticketId);
                            }
                        }
                    };
                    const applicationStore = stores.ApplicationStore.create({}, env);
                    applicationStore.initialize();

                    applicationStore.calendar.initializeDates();
                    applicationStore.soundUI.initFromSettings();

                    if (chatConfigService.isChatFeatureAvailable) {
                        chatConfigService.setApiSettings(env.settingsFromApi);
                        applicationStore.chat.setCanShowChat(chatConfigService.canShowChatOnStart());
                    }
                    if (applicationStore.canShowAddPublicLinkToTicketToChat) {
                        processAddTicketLinkToChatFromUrl(applicationStore);
                    }

                    env.ticketRateSyncService = {
                        getRows: (): Map<string, number> => {
                            return applicationStore.ticketWrapper.getSelectionsToCompare();
                        },
                        ratesChanged: (items: { id: string, rate: number }[]): void => {
                            applicationStore.ticketWrapper.ratesChanged(items);
                        }
                    }

                    connectionMonitorService.setHeartbeatService(dateTimeAndHeartbeatService);
                    connectionMonitorService.subscribeConnectionStatusChange((status) => { applicationStore.setConnectionStatus(status); });

                    let cashoutAllowed = env.loggedUserId > 0;
                    applicationStore.cashOutList.setIsAllowed(cashoutAllowed);
                    if (cashoutAllowed) {
                        applicationStore.subscribeToMtsCashoutAsync();
                    }

                    env.scoreChangeMonitor.setEventIsFavoriteProvider(applicationStore.events);

                    if (applicationStore.chat.canShowChat) { // chat is shown in liveApp.tsx as simple component
                        applicationStore.subscribeToChatAsync();
                    }

                    if (response.data.RightColumnBanners) {
                        applicationStore.rightColumnBanners.processData(response.data.RightColumnBanners);
                    }

                    if (__IsMTSTipos__) {
                        applicationStore.marketingAction.prepareData(response.data.MarketingActions);
                    }

                    //TODOHXC applicationStore.couponWrapper.setCouponData(response.data.CouponOnTabs);
                    //TODOHX applicationStore.rightSide.setData(response.data.RightColumnItems) * /

                    render(
                        <AppContainer>
                            <stores.Provider applicationStore={applicationStore}>
                                <App />
                            </stores.Provider>
                        </AppContainer>,
                        rootEl
                    );

                    new UserService().checkUserIdentityOnInit(env.settings.userSecureId, env.player, loggingService, sportsBettingApi);
                } catch (e) {
                    loggingService.error(e);
                    processCriticalError(launchSettings.isDebug, e);
                }
            })
            .catch(e => {
                loggingService.error(e.error);
                processCriticalError(launchSettings.isDebug, e.error, e.isRecaptchaInvalid);
            });

        render(__IsMTS__ && launchSettings.initLoader ? <AppLoaderMts minHeight={launchSettings.initLoader.height} loadingText={launchSettings.initLoader.text} /> : <AppLoader />, rootEl);
    } catch (e) {
        processCriticalError(document.location.href.indexOf("http://localhost:808") === 0, e);
    }

    function processCriticalError(isDebug: boolean, e: Error, isRecaptchaInvalid: boolean = false) {
        if (isDebug) {
            render(<div>{translation().general_ErrorInInitialization} {e}</div>, rootEl);
        } else {
            let ref = location.href;
            let posDoubleSlash = location.href.indexOf('//');
            if (posDoubleSlash > 0) {
                let posSlashRelative = location.href.indexOf('/', posDoubleSlash + 2);
                if (posSlashRelative > 0) {
                    ref = location.href.substr(posSlashRelative);
                }
            }
            let showRecaptchaError = '';
            if (isRecaptchaInvalid) {
                showRecaptchaError = '&showRecaptchaError=true'
            }
            location.href = '/live-error-on-open/?ref=' + encodeURI(ref) + showRecaptchaError;
        }
    }

    function getApiSettings(responseDataFromApi: any): ILiveApiSettings { //TODO same in eTipMobile
        return {
            isBetDay: responseDataFromApi.IsBetDay,
            timeForCoupon: responseDataFromApi.TimeForCoupon * 1000, // how long wait when sending live coupon (couponPay), milliseconds
            timeForCashout: responseDataFromApi.TimeForCoupon * 1000,
            currencyToPointsRatio: responseDataFromApi.CurrencyToPointsRatio,
            ticketStakeDecimalPlaces: responseDataFromApi.TicketStakeDecimalPlaces,
            canPrepareTicket: responseDataFromApi.CanPrepareTicket,
            stakeMin: responseDataFromApi.StakeMin,
            combiStakeMin: responseDataFromApi.CombiStakeMin,
            canShowChat: responseDataFromApi.ShowChat
        }
    }

    const addTicketLinkToChatRegExp = new RegExp("\\?couponToChat\\=([a-fA-Z0-9]{32})&?.*$");
    const addTicketLinkToChatLegacyRegExp = new RegExp("\\?couponToChatl\\=([a-fA-Z0-9]{32})&?.*$");
    const processAddTicketLinkToChatFromUrl = (applicationStore: Instance<typeof stores.ApplicationStore>): void => {
        loggingService.info(document.location.hash); //couponToChat
        if (document.location.hash) {
            let match = addTicketLinkToChatRegExp.exec(document.location.hash);
            if (match && match.length) {
                applicationStore.chat.addTicketPublicLinkAfterLoad(match[1], false);
                return;
            }
            match = addTicketLinkToChatLegacyRegExp.exec(document.location.hash);
            if (match && match.length) {
                applicationStore.chat.addTicketPublicLinkAfterLoad(match[1], true);
                return;
            }
        }
    }
}
